// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshProducts (state, products) {
    state.list = products
  },
  refreshProductDetails (state, productDetails) {
    var existingDetails = state.detailsList.find(p => {
      return p.contentNodeId === productDetails.nodeId
    })
    if (!existingDetails) {
      state.detailsList.push(productDetails)
    } else {
      existingDetails.description = productDetails.description
      existingDetails.faqs = productDetails.faqs
      existingDetails.dataSheets = productDetails.dataSheets
      existingDetails.videos = productDetails.videos
      existingDetails.kbArticles = productDetails.kbArticles
    }
  },
  updateProducts (state, products) {
    console.log('update products', products)
    // if product is deleted, add to delete list (or replace if already in it)
    // if not deleted, update existing product
    products.forEach(product => {
      if (product.deleted) {
        var existingDeleteIndex = state.deletedList.findIndex(p => p.uid === product.uid)
        if (existingDeleteIndex > -1) {
          state.deletedList.splice(existingDeleteIndex, 1, product)
        } else {
          state.deletedList.push(product)
        }
      } else {
        var existingIndex = state.list.findIndex(
          p => p.uid === product.uid
        )
        if (existingIndex > -1) {
          state.list.splice(existingIndex, 1, product)
        } else {
          state.list.push(product)
        }
      }

      // for each variant if its deleted, add a link to variantDeletedList
      for (let index = product.variants.length - 1; index > -1; index--) {
        var variant = product.variants[index]
        if (variant.deleted) {
          // remove this variant from the product in the main list as we do not want it to show up in listings

          var existingvariantDeleteIndex = state.variantDeletedList.findIndex(v => v.uid === variant.uid)
          if (existingvariantDeleteIndex > -1) {
            state.variantDeletedList[existingvariantDeleteIndex].variant = variant
          } else {
            state.variantDeletedList.push({
              uid: variant.uid,
              productUid: product.uid,
              variant: variant,
            })
          }
          product.variants.splice(index)
        }
      }
    })
    state.variantDeletedList.forEach(element => { console.log(element.uid) })
  },
}
